import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTuinaShiftOptions } from '@/service/tuina'

export const fetchTuinaShiftOptions = createAsyncThunk(
  'tuinaShiftOptions/fetchTuinaShiftOptions',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getTuinaShiftOptions(query)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载班次选项失败'
      )
    }
  }
)

const shiftOptionsSlice = createSlice({
  name: 'tuinaShiftOptions',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTuinaShiftOptions.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchTuinaShiftOptions.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || []
      })
      .addCase(fetchTuinaShiftOptions.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
      })
  }
})

export default shiftOptionsSlice.reducer
